import {BoundingBox2D, BoundingBox3D} from '@wandb/weave/common/types/media';

import {useSelector} from '../../../state/hooks';

export type BoundingBoxData = Record<
  string,
  Record<string, BoundingBox2D[] | BoundingBox3D[]>
>;

/**
 * For a given panel ref, get the bounding box data out of the Redux state. This
 * requires the Redux state to be in context.
 *
 * @param panelRefId
 */
export function useBoxData(panelRefId: string) {
  // QUESTION: should this hook depend on Redux? It seems inappropriate to
  //           interact with context implicitly this deep in the tree.
  // This data is put into redux where the bounding box data is loaded by the
  // UI, specifically where loadBoxData() is called
  return useSelector<BoundingBoxData | undefined>(s => {
    return s.media.boxData[panelRefId];
  });
}
